import React, { useState } from 'react';
import { useUser } from '../context/UserContext';
import { usePortfolio } from '../context/PortfolioContext';
import TopStocks from './TopStocks';
import PortfolioOverview from './PortfolioOverview';
import PortfolioDetails from './PortfolioDetails';
import StockHistory from './StockHistory';
import TransactionHistory from './TransactionHistory';
import TradingInterface from './TradingInterface';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { state: userState } = useUser();
  const { state: portfolioState } = usePortfolio();
  const [activeTab, setActiveTab] = useState<'overview' | 'trading' | 'history'>('overview');

  // Use portfolioState to avoid unused variable warning
  console.log('Portfolio state:', portfolioState);

  if (!userState.isOnboarded || !userState.user) {
    return <div>Please complete onboarding first.</div>;
  }

  const tabs = [
    { id: 'overview', label: 'Overview', icon: '📊' },
    { id: 'trading', label: 'Trading', icon: '💹' },
    { id: 'history', label: 'History', icon: '📈' }
  ] as const;

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <h1 className="dashboard-title">Welcome back, {userState.user.name}!</h1>
            <p className="dashboard-subtitle">Manage your virtual portfolio</p>
          </div>
          <div className="header-right">
            <div className="user-info">
              <div className="user-avatar">
                {userState.user.name.charAt(0).toUpperCase()}
              </div>
              <div className="user-details">
                <span className="user-name">{userState.user.name}</span>
                <span className="user-status">Virtual Investor</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <nav className="dashboard-nav">
        <div className="nav-content">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </nav>

      <main className="dashboard-main">
        <div className="dashboard-content">
          {activeTab === 'overview' && (
            <div className="overview-grid">
              <div className="overview-left">
                <PortfolioOverview />
                <PortfolioDetails />
              </div>
              <div className="overview-right">
                <TopStocks />
                <StockHistory />
              </div>
            </div>
          )}

          {activeTab === 'trading' && (
            <div className="trading-grid">
              <div className="trading-left">
                <TradingInterface />
              </div>
              <div className="trading-right">
                <TopStocks />
                <PortfolioDetails />
              </div>
            </div>
          )}

          {activeTab === 'history' && (
            <div className="history-grid">
              <div className="history-left">
                <TransactionHistory />
              </div>
              <div className="history-right">
                <StockHistory />
                <PortfolioDetails />
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
